module.exports = __webpack_public_path__ + "img/20190524112137微信图片_20190524112104.9fa4b968.jpg";